import * as React from "react"
const SvgMailbox = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M6 10.714H4v10h16v-10h-9a.97.97 0 0 1-.713-.287.97.97 0 0 1-.287-.713.97.97 0 0 1 .287-.712.97.97 0 0 1 .713-.288h9q.824 0 1.413.588.587.587.587 1.412v10a1.93 1.93 0 0 1-.587 1.413 1.93 1.93 0 0 1-1.413.587H4q-.824 0-1.413-.587A1.93 1.93 0 0 1 2 20.714v-10q0-.825.587-1.412A1.93 1.93 0 0 1 4 8.714h2v-5a.97.97 0 0 1 .287-.712A.97.97 0 0 1 7 2.714h6a.97.97 0 0 1 .713.288.97.97 0 0 1 .287.712v2a.97.97 0 0 1-.287.713.97.97 0 0 1-.713.287H8v7a.97.97 0 0 1-.287.713.97.97 0 0 1-.713.287.97.97 0 0 1-.713-.287.97.97 0 0 1-.287-.713z" />
  </svg>
)
export default SvgMailbox
